// The parts the public report renderer composes. The all-in-one
// GroundingSearchVisualization (and the filter bar / detail drawer it owned)
// was only ever mounted by the dissolved Historical Metrics dashboard, so it
// went with it — reports build their own layout from these pieces.
export { GroundingSearchKPIHeader } from "./GroundingSearchKPIHeader";
export { GroundingSearchTable } from "./GroundingSearchTable";
export { GroundingSearchHeatMap } from "./GroundingSearchHeatMap";
export { GroundingSearchList } from "./GroundingSearchList";
export { RankBadge, DualRankBadge } from "./RankBadge";

// Types
export * from "./types";

// Utilities
export * from "./utils";

// Adapters for converting existing data structures
export * from "./adapters";
